export type DtoType = string;

export const DTO_DEFAULT: DtoType = 'Dto.Default';
export const DTO_DEFAULT_CREATE: DtoType = 'Dto.Default.Create';
export const DTO_DEFAULT_UPDATE: DtoType = 'Dto.Default.Update';
export const DTO_DEFAULT_PATCH: DtoType = 'Dto.Default.Patch';
export const DTO_DEFAULT_GET: DtoType = 'Dto.Default.Get';
export const DTO_CUSTOM: DtoType = 'Dto.Custom';
